import { supabase } from '../lib/supabase'
import { TASK_ORG, TASK_PROJECT } from '../lib/releaseTaskLinks'
import { isWorkflowReadOnlyHost } from '../lib/workflowOwner'
import { isTaskStatus, lowerThanReview, type ReleaseTaskStatus } from '../lib/releaseTaskStatus'

// Existing command-center taskStatus entry point, shared by both screens.
// No release component writes tasks. Keep the existing authenticated RLS writer
// here; completion uses the same complete_task_tree RPC as Hub tasks.
export async function taskStatus(id:string,status:ReleaseTaskStatus,options:{manual?:boolean;expected?:string;onlyLower?:boolean}={}) {
  if(isWorkflowReadOnlyHost(location.hostname))throw Error('פעולות שמירה חסומות בפריוויו')
  if(!/^[a-f0-9-]{36}$/i.test(id)||!isTaskStatus(status))throw Error('פרטי המשימה אינם תקינים')
  if(options.manual||options.onlyLower){
    const {data,error}=await supabase.auth.getUser()
    if(error||data.user?.email?.toLowerCase()!=='nizan@otomator.co.il')throw Error('עדכון מצב המשימה זמין לניצן בלבד')
  }
  const read=()=>supabase.from('tasks').select('id,status').eq('id',id).eq('organization_id',TASK_ORG).eq('project_id',TASK_PROJECT).is('archived_at',null).maybeSingle()
  const current=await read()
  if(current.error||!current.data)throw Error('לא ניתן לאמת משימה פעילה. יש לרענן או לקשר למשימה')
  const previous=current.data.status as string
  if(options.onlyLower&&!(status==='approved'?['todo','in_progress','review'].includes(previous):lowerThanReview(previous)))return current.data
  if(options.expected!==undefined&&previous!==options.expected)throw Error('מצב המשימה השתנה. יש לרענן ולנסות שוב')
  if(previous===status)return current.data
  if(!options.manual&&!options.onlyLower){
    const allowed=status==='in_progress'?['todo']:status==='review'?['todo','in_progress','waiting']:['todo','in_progress','waiting','review']
    if(!allowed.includes(previous))return current.data
  }
  if(status==='done'){
    const children=await supabase.from('tasks').select('id').eq('parent_task_id',id).eq('organization_id',TASK_ORG).eq('project_id',TASK_PROJECT).is('archived_at',null).neq('status','done')
    if(children.error)throw Error('לא ניתן לבדוק את משימות המשנה')
    const close=Boolean(children.data?.length)&&window.confirm(`למשימה יש ${children.data!.length} משימות משנה פתוחות. לסמן גם אותן כבוצעו? ביטול מסמן רק את המשימה הראשית.`)
    const completed=await supabase.rpc('complete_task_tree',{p_task_id:id,p_close_open_subtasks:close})
    if(completed.error)throw Error('סימון המשימה כבוצעה נכשל. יש לרענן ולנסות שוב')
  }else{
    const changed=await supabase.from('tasks').update({status}).eq('id',id).eq('organization_id',TASK_ORG).eq('project_id',TASK_PROJECT).is('archived_at',null).eq('status',previous).select('id,status').maybeSingle()
    if(changed.error||!changed.data)throw Error('עדכון מצב המשימה לא אושר. ייתכן שהמצב השתנה; יש לרענן')
  }
  const saved=await read()
  if(saved.error||!saved.data||saved.data.status!==status&&!(status==='done'&&saved.data.status==='review'))throw Error('לא ניתן לאמת את תוצאת עדכון המשימה. יש לרענן לפני ניסיון נוסף')
  return saved.data
}
